import styled from 'styled-components';

export const HeaderRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 8px;
`;

export const EditToggleButton = styled.button`
  background: none;
  border: 1px solid #0090d3;
  color: #0090d3;
  border-radius: 100px;
  padding: 6px 14px;
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;

export const RowsGrid = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const ParcelaRowGrid = styled.div`
  display: grid;
  grid-template-columns: 0.4fr 1fr 1fr;
  gap: 8px;
  align-items: center;
`;

export const CellInput = styled.input`
  padding: 6px 10px;
  border: 1px solid #ddd;
  border-radius: 8px;
  font-size: 12px;
  outline: none;
  width: 100%;
  box-sizing: border-box;
  background: #fff;
  color: #333;

  &:focus {
    border-color: #0090d3;
  }

  &:disabled {
    background: #f0f0f0;
    color: #888;
    cursor: not-allowed;
  }
`;

export const TotalsBanner = styled.div<{ $ok: boolean }>`
  display: flex;
  justify-content: space-between;
  gap: 12px;
  flex-wrap: wrap;
  font-size: 11px;
  padding: 8px 10px;
  border-radius: 8px;
  background: ${(p) => (p.$ok ? '#e6f9f1' : '#fff7e6')};
  color: ${(p) => (p.$ok ? '#00845e' : '#996b00')};
`;

export const AdjustLink = styled.button`
  background: none;
  border: none;
  color: #0090d3;
  font-size: 11px;
  font-weight: 600;
  text-decoration: underline;
  cursor: pointer;
  padding: 0;
`;

export const ConditionBadge = styled.span`
  font-size: 11px;
  font-weight: 700;
  color: #0090d3;
  background: #e3f2fd;
  border-radius: 100px;
  padding: 2px 10px;
`;

export const SaveCancelBar = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  margin-top: 4px;
`;

export const SmallOutlineButton = styled.button`
  background: #fff;
  color: #0090d3;
  border: 1px solid #0090d3;
  padding: 8px 16px;
  border-radius: 100px;
  font-size: 12px;
  font-weight: 700;
  cursor: pointer;

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }
`;

export const SmallSolidButton = styled.button`
  background: #0090d3;
  color: #fff;
  border: none;
  padding: 8px 16px;
  border-radius: 100px;
  font-size: 12px;
  font-weight: 700;
  cursor: pointer;

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }
`;

export const EditedNotice = styled.div`
  font-size: 11px;
  color: #996b00;
  background: #fff7e6;
  border-radius: 6px;
  padding: 6px 10px;
`;
